import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Country, PhoneCodesService } from '../../../services/phone-codes/phone-codes.service'; 

@Component({
  selector: 'app-input-tel',
  standalone: false,
  templateUrl: './input-tel.component.html',
  styleUrl: './input-tel.component.scss'
})
export class InputTelComponent implements OnInit {

  @Input() phoneValue: string = '';
  @Input() phoneCode: string = '';
  @Output() phoneValueChange = new EventEmitter<string>();
  @Input() name: string = '';
  @Output() changeCustomerPhone = new EventEmitter<void>();


  countries: Country[] = [];
  isFocusedInput: boolean = false;
  selectedPhoneCode: Country|null = null;

  constructor(private phoneCodesService: PhoneCodesService) {}

  ngOnInit(): void {
    this.getPhoneCodes();
  }

  ngOnChanges(changes: SimpleChanges): void {
   if (changes['phoneCode'] && this.countries.length > 0) {
     setTimeout(() => {
       this.updateSelectedPhoneCode();
     });
   }
  }


  toggleDropdown() {
    event.stopPropagation();
    this.isFocusedInput = !this.isFocusedInput;
  }

  onChangeInputTel() {
    this.isFocusedInput = false;
  }

  getPhoneCodes() {
    this.phoneCodesService.getCountries().subscribe(data => {
      this.countries = data;
      this.updateSelectedPhoneCode();
    });
  }

 selectPhoneCode(index: number) {
  const newlySelected = this.countries[index];

  const isSameCountry = this.selectedPhoneCode?.dialCode === newlySelected.dialCode;

  this.selectedPhoneCode = newlySelected;
  this.isFocusedInput = false;

  if (!isSameCountry || this.phoneValue !== '') {
    this.phoneValueChange.emit('');
    this.changeCustomerPhone.emit();
  }
}


  onChangeCustomerPhone() {
    this.changeCustomerPhone.emit();
  }

  get formattedPhone(): string {
    return this.phoneValue ? '+' + this.phoneValue : '';
  }

  set formattedPhone(value: string) {
    const cleaned = value.replace(/\D/g, '');
    this.phoneValueChange.emit(cleaned);
    this.changeCustomerPhone.emit();
  }

  updateSelectedPhoneCode() {
    if (this.phoneCode === '3') {
      this.selectedPhoneCode = this.countries[1];
    } else if (this.phoneCode === '1') {
      this.selectedPhoneCode = this.countries[0];
    } else if (this.phoneCode == '' || this.phoneValue == null) {
      this.selectedPhoneCode = this.countries[0]
    }
  }

  copiedTooltipVisible: boolean = false;
  private copyTimeoutId: any;

  copyTextToClipboard(event: Event): void {
    event.stopPropagation();
    event.preventDefault();

    this.copiedTooltipVisible = true;
    
    if (this.copyTimeoutId) {
      clearTimeout(this.copyTimeoutId);
    }

    navigator.clipboard.writeText(this.phoneValue).then(() => {
      this.copyTimeoutId = setTimeout(() => {
        this.copiedTooltipVisible = false;
        this.copyTimeoutId = null;
      }, 1000);
    })
  }

}
